import { isNull, keys } from 'lodash';
// Import Constants
import { ErrorShowType, l, TemplateInputTypes } from 'constants/common';

const whatsAppTemplateLanguageScenario = () => ({
    isValid: null,
    errorText: '',
    value: null,
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ],
});

const whatsAppTemplateLanguageDetailsScenario = () => ({
    isValid: null,
    errorText: '',
    value: null,
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'externalWhatsAppTemplateDetails',
            ErrorMessage: '',
            ParametersValues: null,
        },
    ],
});

const whatsAppTemplateIdScenario = () => ({
    isValid: null,
    errorText: '',
    value: null,
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ],
});

const whatsAppPlaceholderMappingScenario = () => ({
    isValid: null,
    errorText: '',
    value: null,
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'whatsAppPlaceholderMappingRequired',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ],
});

const whatsAppTemplateValidationScenario = () => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    [`defaultLang${TemplateInputTypes.ExternalWhatsAppTemplateLanguage}`]: {
        ...whatsAppTemplateLanguageScenario(),
    },
    [`defaultLang${TemplateInputTypes.ExternalWhatsAppTemplateDetails}`]: {
        ...whatsAppTemplateLanguageDetailsScenario(),
    },
    [`defaultLang${TemplateInputTypes.ExternalWhatsAppTemplateId}`]: {
        ...whatsAppTemplateIdScenario(),
    },
    [`defaultLang${TemplateInputTypes.ExternalWhatsAppTemplatePlaceholderMapping}`]: {
        ...whatsAppPlaceholderMappingScenario(),
    },
});

const whatsAppTemplateScenarioPropertiesCreator = (data, editCloneMode) => {
    if (editCloneMode) {
        return keys(data).reduce((acc, id) => {
            acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateLanguage}`] = {
                ...whatsAppTemplateLanguageScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id][TemplateInputTypes.ExternalWhatsAppTemplateLanguage],
            };
            acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateDetails}`] = {
                ...whatsAppTemplateLanguageDetailsScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id][TemplateInputTypes.ExternalWhatsAppTemplateDetails],
            };
            acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateId}`] = {
                ...whatsAppTemplateIdScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id][TemplateInputTypes.ExternalWhatsAppTemplateId],
            };
            acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplatePlaceholderMapping}`] = {
                ...whatsAppPlaceholderMappingScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: {
                    mapping: data[id][TemplateInputTypes.ExternalWhatsAppTemplatePlaceholderMapping] ?? null,
                    requiredPlaceholders: [],
                },
            };
            return acc;
        }, {});
    }

    return data.reduce((acc, id) => {
        acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateLanguage}`] = { ...whatsAppTemplateLanguageScenario() };
        acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateDetails}`] = {
            ...whatsAppTemplateLanguageDetailsScenario(),
        };
        acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplateId}`] = { ...whatsAppTemplateIdScenario() };
        acc[`${id}${TemplateInputTypes.ExternalWhatsAppTemplatePlaceholderMapping}`] = {
            ...whatsAppPlaceholderMappingScenario(),
        };
        return acc;
    }, {});
};

export { whatsAppTemplateValidationScenario, whatsAppTemplateScenarioPropertiesCreator };
